import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';

export const AdminLogin = () => {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login } = useAdminAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inp = { width: '100%', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 8, padding: '11px 14px', color: '#0F172A', fontSize: 14, outline: 'none', boxSizing: 'border-box' };

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <img src="/assets/mars-logo.png" alt="MarsResume logo" style={{ width: 48, height: 48, objectFit: 'contain', display: 'block' }} />
            <div>
              <div style={{ color: '#0F172A', fontWeight: 900, fontSize: 20 }}>MarsResume</div>
              <div style={{ color: '#FB923C', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 2 }}>Admin Panel</div>
            </div>
          </div>
          <h2 style={{ margin: '16px 0 4px', color: '#0F172A', fontSize: 22, fontWeight: 800 }}>Welcome back, Admin</h2>
          <p style={{ margin: 0, color: '#64748B', fontSize: 13 }}>Sign in to manage your platform</p>
        </div>

        <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: 16, padding: 28, boxShadow: '0 20px 60px rgba(15,23,42,0.10)' }}>
          {error && (
            <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', color: '#DC2626', padding: '10px 14px', borderRadius: 8, marginBottom: 18, fontSize: 13 }}>
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', color: '#64748B', fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Email Address</label>
              <input type="email" style={inp} value={email} onChange={e => setEmail(e.target.value)} required placeholder="admin@resumeai.com" />
            </div>
            <div style={{ marginBottom: 22 }}>
              <label style={{ display: 'block', color: '#64748B', fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Password</label>
              <input type="password" style={inp} value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••" />
            </div>
            <button type="submit" disabled={loading} style={{ width: '100%', background: loading ? '#E2E8F0' : 'linear-gradient(135deg,#EF1D28,#FB923C)', color: 'white', border: 'none', borderRadius: 8, padding: '12px', fontWeight: 700, fontSize: 15, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Signing in...' : 'Sign In to Admin Panel'}
            </button>
          </form>

        </div>
      </div>
    </div>
  );
};
